import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
import VueApexCharts from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import JsonExcel from "vue-json-excel3";
import Toast, { PluginOptions } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

const options : PluginOptions = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
};

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(Toast, options);

ApiService.init(app);
// MockAdapter.init(app);
app.component('apexchart', VueApexCharts);
app.component("downloadExcel", JsonExcel);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
